import React, { useEffect, useState, useRef } from 'react'
import { addZero, convertMinsToHrsMins } from 'utils/helpers'
import './style.css'
import { v4 } from 'uuid'
import { TimePickerContainer, TimePickerDisplay, TimePickerOptions } from './HonestTimePicker.styled'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { darkTheme, lightTheme } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'

export const HonestTimePicker = ({ onChange, defaultValue, calculated, reset }: IHonestTimePicker) => {
  const hours = []
  const minutes = []
  const [state, setState] = useState({ hours: '--', minutes: '--' })
  const [displayOptions, setDisplayOptions] = useState(false)
  const [defaultSet, setDefaultSet] = useState(false)
  const didMount = useRef(false)
  const { darkMode } = useSelector((state: RootState) => state.globals)

  useEffect(() => {
    if (didMount.current) {
      setState({ hours: '--', minutes: '--' })
      defaultValue = null
      return
    } else {
      didMount.current = true
    }
  }, [reset])

  const handleTime = (type, value) => {
    setState((prev) => {
      const newObj = { ...prev }
      if (type == 'hours' && state.minutes == '--') {
        newObj.minutes = '00'
        newObj.hours = value
      } else if (type == 'minutes' && state.hours == '--') {
        newObj.hours = '00'
        newObj.minutes = value
      } else {
        newObj[type] = value
      }
      return newObj
    })
  }

  useEffect(() => {
    onChange && state.hours !== '--' && onChange(state.hours + ':' + state.minutes)
  }, [state])

  useEffect(() => {
    if (!defaultSet)
      if (!isNaN(defaultValue) && !calculated) {
        const splitted = convertMinsToHrsMins(defaultValue).split(':')
        setState({ hours: splitted[0], minutes: splitted[1] })
        setDefaultSet(true)
      } else if (!isNaN(defaultValue) && calculated) {
        const splitted = convertMinsToHrsMins(defaultValue, calculated).split(':')
        setState({ hours: splitted[0], minutes: splitted[1] })
        setDefaultSet(true)
      }
  }, [defaultValue])

  for (let i = 0; i <= 23; i++) {
    hours.push(
      <div
        key={v4()}
        className={
          addZero(i) === parseInt(state.hours) ? 'time-item time-active' : 'time-item'
        }
        onClick={() => handleTime('hours', addZero(i))}
      >
        <BodyText>{addZero(i)}</BodyText>
      </div>,
    )
  }
  for (let i = 0; i <= 59; i++) {
    minutes.push(
      <div
        key={v4()}
        className={
          addZero(i) === parseInt(state.minutes) ? 'time-item time-active' : 'time-item'
        }
        onClick={() => handleTime('minutes', addZero(i))}
      >
        <BodyText>{addZero(i)}</BodyText>
      </div>,
    )
  }

  const active = !(state.hours == '--' || state.minutes == '--')

  const shadow =
    active ? '0px 0px 30px rgba(0, 0, 0, 0.1)' : 'none'
  const border = !active ?
    darkMode ? darkTheme.inputBorder : lightTheme.inputBorder : 'none'
  const background = active ? (darkMode ? darkTheme.inputActiveBackground : lightTheme.inputActiveBackground) : darkMode ? darkTheme.appBackground : lightTheme.appBackground


  return (
    <TimePickerDisplay
      active={!(active)}
      tabIndex={-1}
      onBlur={() => setDisplayOptions(false)}
      onClick={() => setDisplayOptions((prev) => !prev)}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //  @ts-ignore
      style={{ shadow, border, background }}
    >
      <BodyText>{state.hours + ' : ' + state.minutes}</BodyText>
      {displayOptions && (
        <TimePickerOptions>
          <TimePickerContainer><BodyText>{hours}</BodyText></TimePickerContainer>
          <TimePickerContainer>
            <BodyText>{minutes}</BodyText>
          </TimePickerContainer>
        </TimePickerOptions>
      )}
    </TimePickerDisplay>
  )
}


interface IHonestTimePicker {
  onChange: (value: string) => void
  defaultValue: any
  calculated: number
  reset?: boolean
}